var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1521_2255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1521_2255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41683 16.6666C4.15294 16.6666 3.07322 16.2291 2.17766 15.3541C1.28155 14.4791 0.833496 13.4097 0.833496 12.1458C0.833496 11.0625 1.15988 10.0972 1.81266 9.24996C2.46544 8.40274 3.31961 7.86107 4.37516 7.62496C4.61127 6.62496 5.20155 5.67357 6.146 4.77079C7.09044 3.86801 8.09738 3.41663 9.16683 3.41663C9.62516 3.41663 10.0177 3.57968 10.3443 3.90579C10.6704 4.23246 10.8335 4.62496 10.8335 5.08329V10.125L12.1668 8.83329L13.3335 9.99996L10.0002 13.3333L6.66683 9.99996L7.8335 8.83329L9.16683 10.125V5.08329C8.11127 5.27774 7.29183 5.78801 6.7085 6.61413C6.12516 7.44079 5.8335 8.29163 5.8335 9.16663H5.41683C4.61127 9.16663 3.92377 9.45135 3.35433 10.0208C2.78488 10.5902 2.50016 11.2777 2.50016 12.0833C2.50016 12.8888 2.78488 13.5763 3.35433 14.1458C3.92377 14.7152 4.61127 15 5.41683 15H15.4168C16.0002 15 16.4932 14.7986 16.896 14.3958C17.2988 13.993 17.5002 13.5 17.5002 12.9166C17.5002 12.3333 17.2988 11.8402 16.896 11.4375C16.4932 11.0347 16.0002 10.8333 15.4168 10.8333H14.1668V9.16663C14.1668 8.49996 14.0141 7.87829 13.7085 7.30163C13.4029 6.72552 13.0002 6.23607 12.5002 5.83329V3.89579C13.5279 4.3819 14.3404 5.10079 14.9377 6.05246C15.5349 7.00357 15.8335 8.04163 15.8335 9.16663C16.7918 9.27774 17.5871 9.69079 18.2193 10.4058C18.851 11.1213 19.1668 11.9583 19.1668 12.9166C19.1668 13.9583 18.8024 14.8438 18.0735 15.5733C17.344 16.3022 16.4585 16.6666 15.4168 16.6666H5.41683Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.4f6153a10aceea305f046c6079f3a39f.svg";
export { ForwardRef as ReactComponent };